import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header_Footer/Header";
import Footer from "../components/Header_Footer/Footer";

const STANDALONE_ROUTES = ["/escape-the-heat"];

function Layout({ children }) {
  const { pathname } = useLocation();
  const standalone = STANDALONE_ROUTES.includes(pathname);

  if (standalone) {
    return <div>{children}</div>;
  }

  return (
    <div>
      <Header />
      {children}
      <Footer />
    </div>
  );
}

export default Layout;
